export default {
    name: 'Sebastian Klaus - Softwareentwicklung und Beratung',
};